import React, { Component } from "react";
import { IsEmpty } from "../../../util/commonFunctions";

let closeModal = false;
class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      revealId: props.modalID,
      styleTop: {
        top: "0"
      },
      openPopup: props.openPopup
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.openPopup !== prevState.openPopup && !closeModal) {
      return { openPopup: nextProps.openPopup };
    }

    return null;
  }

  clickHandler = event => {
    // if (
    //   !IsEmpty(document.getElementsByClassName("modal-content")) &&
    //   !IsEmpty(document.getElementsByClassName("modal-content")[0]) &&
    //   document.getElementById(this.state.revealId).contains(event.target) &&
    //   !document
    //     .getElementsByClassName("modal-content")[0]
    //     .contains(event.target)
    // ) {
    //   this.closeModal();
    // }
  };

  resizeHandler = () => {
    this.setState({
      styleTop: {
        top: "0"
      }
    });
    if (window.innerWidth > 640) {
      this.alignVerticallyCenter();
    }
  };

  componentDidMount = () => {
    document.addEventListener("click", this.clickHandler);
    if (this.state.openPopup) {
      this.addClassBody();
    }

    /* if (window.innerWidth > 640) {
      this.alignVerticallyCenter();
    }

    window.addEventListener("resize", this.resizeHandler); */
  };

  componentWillUnmount = () => {
    document.removeEventListener("click", this.clickHandler);
    if (this.state.openPopup) {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
    // window.removeEventListener("resize", this.resizeHandler);
  };

  addClassBody = () => {
    document.getElementsByTagName("body")[0].classList.add("modal-open"); // += " modal-open";
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  };

  alignVerticallyCenter = () => {
    if (!IsEmpty(document.getElementById(this.state.revealId + "overlay"))) {
      document
        .getElementById(this.state.revealId + "overlay")
        .classList.add("hidden-overlay");
      if (
        window.innerHeight >
        document.getElementById(this.state.revealId).offsetHeight
      ) {
        const tempVar =
          window.innerHeight -
          document.getElementById(this.state.revealId).offsetHeight;
        this.setState({
          styleTop: {
            top: tempVar / 2
          }
        });
      }

      document
        .getElementById(this.state.revealId + "overlay")
        .classList.remove("hidden-overlay");
    }
  };

  componentDidUpdate = () => {
    closeModal = false;
    // if (!this.state.openPopup) {
    //   document.getElementsByTagName("body")[0].classList.remove("modal-open");
    //   document.getElementsByTagName("body")[0].style.overflow = "visible";
    // }
  };

  closeModal = () => {
    closeModal = true;
    this.props.resetPopupProps();
    this.setState({
      openPopup: false
    });
  };

  render() {
    if (this.state.openPopup) {
      this.addClassBody();
    }
    return (
      <React.Fragment>
        <div
          id={this.state.revealId}
          className={this.state.openPopup ? "modal show" : "modal"}
          tabIndex="-1"
          role="dialog"
          aria-labelledby={this.state.revealId}
          aria-hidden={!this.state.openPopup}
          style={
            this.state.openPopup ? { display: "block" } : { display: "none" }
          }
        >
          <div className= {this.state.revealId=="playerPopUp"  ? "player-modal-dialog" : "modal-dialog" } role="document">
            <div className="modal-content">
              {this.props.children &&
                React.Children.map(this.props.children, child =>
                  React.cloneElement(child, {
                    closeModal: this.closeModal,
                    openPopup: this.state.openPopup
                  })
                )}
            </div>
          </div>
        </div>
        <div
          id={this.state.revealId + "overlay"}
          className={this.state.openPopup ? "modal-backdrop show" : ""}
        ></div>
      </React.Fragment>
    );
  }
}

export default Modal;
